import { render, staticRenderFns } from "./TopBest.vue?vue&type=template&id=5b0c69d6"
import script from "./TopBest.vue?vue&type=script&lang=js"
export * from "./TopBest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports